import React from 'react'
import './Eng_banner.css'

const Eng_banner = () => {
  return (
    <>
        <section className='enggagement_banner'>
            <div className='container-fluid'>
                <div className='bannerdiv'>
                    <img className='engbanner' src={process.env.PUBLIC_URL + '/assets/images/enggagement/banner/eng-banner.webp'} alt="banner" />

                    <h5 className='h5bantitle'>The Engagement Ring</h5>
                </div>
            </div>
        </section>
    </>
  )
}

export default Eng_banner